import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Preference } from '../../../../avisDePub/preferences-avis-de-pub/model/preference';
import { Step4 } from '../../../../shared/models/component-messages/simp_in/step4';
import { ArrayPopTools } from '../../../../shared/services/array-pop-tools';
import { Lot } from '../models/Lot';
import { TypeLotsFNSSimple } from '../models/TypeLotsFNSSimple';
import { TypeOuiNon } from '../models/TypeOuiNon';
import { Initial } from '../models/Initial';


@Component({
	selector: 'app-type-lotsFNS-simple',
	templateUrl: './type-lotsFNS-simple.component.html'
})
export class TypeLotsFNSSimpleComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'TypeLotsFNSSimple';
	@Input() parentForm: FormGroup;

	@Input() disabled: boolean;
	@Input() initial: Initial;

	public step4 = new Step4();
	public haveLot = new TypeOuiNon();

	constructor() {
	}

	public ngOnInit() {
		if (!this.initial.lots) {
			this.initial.lots = new TypeLotsFNSSimple();
		}
		if (!this.initial.lots.lot || this.initial.lots.lot.length === 0) {
			this.initial.lots.lot = [];
		}
		if (this.initial.isMarcheAlloti === true) {
			this.haveLot.oui = true;
			this.haveLot.non = null;
		} else if (this.initial.isMarcheAlloti === false) {
			this.haveLot.oui = null;
			this.haveLot.non = true;
		} else {
			this.haveLot.oui = null;
			this.haveLot.non = null;
		}
	}

	addlot() {
		this.initial.lots.lot.push(new Lot());
	}

	removelot(i) {
		if (this.initial.lots.lot.length > 1) {
			ArrayPopTools.pop(this.initial.lots.lot, i, this.parentForm, this.getUid());
		}
	}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}

	getStepId() {
		return this.uid.substring(0, this.uid.indexOf('SepSep'));
	}

	isMarcheAlloti() {
		let marcheAlloti = this.parentForm.controls[this.getUid() + '_SepSep_TypeOuiNon_SepAtt_oui'] ?
			this.parentForm.controls[this.getUid() + '_SepSep_TypeOuiNon_SepAtt_oui'].value :
			this.initial.isMarcheAlloti;
		if (marcheAlloti === false || marcheAlloti === 'Non' || marcheAlloti === null) {
			this.initial.lots.lot = [];
			return false;
		} else {
			if (this.initial.lots.lot.length == 0) {
				this.addlot();
			}
			return true;
		}
	}

	chargeDonneePreference(preference: Preference) {
		for (let index = 0; index < preference?.content?.values.length; index++) {
			const element = preference?.content?.values[index];
			let i = index + 1;
			if (index === 0) {
				this.parentForm.get(this.getUid() + '_index_' + i + '_SepSep_Lot_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.setValue(element?.code);
				this.parentForm.get(this.getUid() + '_index_' + i + '_SepSep_Lot_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.markAsTouched();
			} else {
				if (this.parentForm.get(this.getUid() + '_index_' + i + '_SepSep_Lot_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale') === null) {
					this.addlot();
					setTimeout(() => {
						this.parentForm.get(this.getUid() + '_index_' + i + '_SepSep_Lot_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.setValue(element?.code);
						this.parentForm.get(this.getUid() + '_index_' + i + '_SepSep_Lot_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.markAsTouched();
					}, 100);
				} else {
					this.parentForm.get(this.getUid() + '_index_' + i + '_SepSep_Lot_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.setValue(element?.code);
					this.parentForm.get(this.getUid() + '_index_' + i + '_SepSep_Lot_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.markAsTouched();
				}
			}

		}
	}
}
